var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 14,
    viewBox: "0 0 22 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 7.00095C0.5 6.80203 0.579018 6.61127 0.71967 6.47062C0.860322 6.32997 1.05109 6.25095 1.25 6.25095H18.9395L14.219 1.53195C14.0782 1.39112 13.9991 1.20011 13.9991 1.00095C13.9991 0.801784 14.0782 0.610777 14.219 0.469947C14.3598 0.329117 14.5508 0.25 14.75 0.25C14.9492 0.25 15.1402 0.329117 15.281 0.469947L21.281 6.46995C21.3508 6.53962 21.4063 6.62238 21.4441 6.7135C21.4819 6.80462 21.5013 6.9023 21.5013 7.00095C21.5013 7.0996 21.4819 7.19728 21.4441 7.2884C21.4063 7.37951 21.3508 7.46228 21.281 7.53195L15.281 13.5319C15.1402 13.6728 14.9492 13.7519 14.75 13.7519C14.5508 13.7519 14.3598 13.6728 14.219 13.5319C14.0782 13.3911 13.9991 13.2001 13.9991 13.0009C13.9991 12.8018 14.0782 12.6108 14.219 12.4699L18.9395 7.75095H1.25C1.05109 7.75095 0.860322 7.67193 0.71967 7.53128C0.579018 7.39063 0.5 7.19986 0.5 7.00095Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/ArrowRight.0a07ac2c31eabd6deb8329797dcd52e5.svg";
export { ForwardRef as ReactComponent };